import "./BlurredFeature.css";

export default function BlurredFeature({ children, message = "This service is not included in your current package. For purchases and detailed information, please contact: pinar@admongrel.com" }) {
  return (
    <div className="blurred-feature-wrapper">
      <div className="blurred-feature-content">{children}</div>
      <div className="blurred-feature-overlay">
        <span className="blurred-feature-icon">🔒</span>
        <span className="blurred-feature-message">{message}</span>
      </div>
    </div>
  );
}
